import {
  BUILDER_ASSISTANT_SESSION_CACHE_KEY,
  BUILDER_SESSION_CACHE_KEY,
} from './promptBuilderSessionCache';
import { clearLibraryQueryCache } from '../services/libraryQueryCache';

export const ASSISTANT_SESSION_CACHE_KEY = 'assistantSession.v1';
export const LEGACY_ASSISTANT_SESSION_CACHE_KEY = 'freestyleSession.v1';
export const PUBLISH_TOAST_KEY = 'promptHub:publishToast:v1';

const SESSION_KEYS_TO_CLEAR = [
  ASSISTANT_SESSION_CACHE_KEY,
  LEGACY_ASSISTANT_SESSION_CACHE_KEY,
  BUILDER_SESSION_CACHE_KEY,
  BUILDER_ASSISTANT_SESSION_CACHE_KEY,
  PUBLISH_TOAST_KEY,
  'openPromptAfterSave',
  'openDraft',
  'sharedPrompt',
];

const LOCAL_KEYS_TO_CLEAR = [
  'editPromptData',
  'clonedPromptData',
];

export function clearPromptCrewTransientState() {
  clearLibraryQueryCache();
  if (typeof window === 'undefined') return;
  try {
    Object.keys(window.sessionStorage).filter((key) => key.startsWith('promptcrew:library:')).forEach((key) => window.sessionStorage.removeItem(key));
  } catch { /* Storage cleanup is best effort. */ }

  SESSION_KEYS_TO_CLEAR.forEach((key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      /* ignore storage cleanup failures */
    }
  });

  LOCAL_KEYS_TO_CLEAR.forEach((key) => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore storage cleanup failures */
    }
  });
}

export function writePublishToast(message, severity = 'success') {
  if (typeof window === 'undefined' || !message) return;
  try {
    window.sessionStorage.setItem(PUBLISH_TOAST_KEY, JSON.stringify({
      message,
      severity,
      createdAt: Date.now(),
    }));
  } catch {
    /* non-critical */
  }
}

export function consumePublishToast(maxAgeMs = 30000) {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(PUBLISH_TOAST_KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(PUBLISH_TOAST_KEY);
    const parsed = JSON.parse(raw);
    if (!parsed?.message) return null;
    if (parsed.createdAt && Date.now() - Number(parsed.createdAt) > maxAgeMs) return null;
    return parsed;
  } catch {
    window.sessionStorage.removeItem(PUBLISH_TOAST_KEY);
    return null;
  }
}
